"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SubCategoryState;
(function (SubCategoryState) {
    SubCategoryState[SubCategoryState["Loading"] = 0] = "Loading";
    SubCategoryState[SubCategoryState["Loaded"] = 1] = "Loaded";
    SubCategoryState[SubCategoryState["Error"] = 2] = "Error";
})(SubCategoryState || (SubCategoryState = {}));
exports.default = SubCategoryState;
//# sourceMappingURL=SubCategoryState.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/owa-options-core/lib/store/schema/SubCategoryState.js
// module id = 1824
// module chunks = 2 39 105 108